/* Sprawdzanie salda karty podarunkowej po kodzie.

   Jak to dziala, bo nie jest oczywiste:
   Shopify nie ma zadnego adresu, pod ktorym z samego kodu zobaczy sie saldo -
   strona karty siedzi na checkout.shopify.com i ma w adresie tokeny, nie kod.
   Ale Storefront API (od wersji 2025-10) pozwala podpiac kod karty do koszyka
   mutacja cartGiftCardCodesAdd, a odpowiedz zawiera balance. Wiec: tworzymy
   pusty koszyk, podpinamy kod i odczytujemy saldo. Koszyk zostaje pusty i
   niczyj, wiec nie rusza automatyzacji porzuconego koszyka.

   Token Storefront API bierzemy z <script id="shopify-features">, ktory Shopify
   wstrzykuje w kazda strone sklepu. Jest publiczny z zalozenia, zadna aplikacja
   nie jest potrzebna. */
(function () {
  var root = document.querySelector('[data-sk-root]');
  if (!root) return;

  var form = root.querySelector('[data-sk-form]');
  var pole = root.querySelector('[data-sk-kod]');
  var btn = root.querySelector('[data-sk-btn]');
  var btnTxt = root.querySelector('[data-sk-btn-txt]');
  var spin = root.querySelector('[data-sk-spin]');
  var blad = root.querySelector('[data-sk-blad]');
  var wynik = root.querySelector('[data-sk-wynik]');
  var kwota = root.querySelector('[data-sk-kwota]');
  var koncowka = root.querySelector('[data-sk-koncowka]');
  var pusta = root.querySelector('[data-sk-pusta]');
  var reset = root.querySelector('[data-sk-reset]');
  if (!form || !pole || !btn || !wynik) return;

  var WERSJA_API = root.getAttribute('data-api') || '2026-01';
  var korzen = root.getAttribute('data-korzen') || '/';
  var napisy = {
    pusty: root.getAttribute('data-blad-pusty') || 'Wpisz kod karty.',
    krotki: root.getAttribute('data-blad-krotki') || 'Kod karty ma co najmniej 8 znaków.',
    brak: root.getAttribute('data-blad-brak') || 'Nie znaleźliśmy karty o tym kodzie.',
    siec: root.getAttribute('data-blad-siec') || 'Nie udało się sprawdzić karty.',
    czekajBlad: root.getAttribute('data-blad-czekaj') || 'Chwila przerwy - spróbuj ponownie za kilka sekund.',
    czekaj: root.getAttribute('data-czekaj') || 'Sprawdzam',
    przycisk: root.getAttribute('data-przycisk') || 'Sprawdź saldo'
  };

  /* Prosty hamulec: po kilku nieudanych probach kazemy chwile odczekac.
     To nie jest zabezpieczenie - kody sa dlugie i losowe, a Shopify ma wlasne
     limity - tylko higiena, zeby strona nie byla wygodnym miotaczem prob. */
  var nieudane = 0;
  var wolneOd = 0;

  function token() {
    var el = document.getElementById('shopify-features');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent).accessToken || null;
    } catch (e) {
      return null;
    }
  }

  function gql(zapytanie, zmienne) {
    return fetch(korzen.replace(/\/$/, '') + '/api/' + WERSJA_API + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token()
      },
      body: JSON.stringify({ query: zapytanie, variables: zmienne || {} })
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  var MUT_KOSZYK = 'mutation { cartCreate { cart { id } } }';
  var MUT_KARTA =
    'mutation($cartId: ID!, $kody: [String!]!) {' +
    '  cartGiftCardCodesAdd(cartId: $cartId, giftCardCodes: $kody) {' +
    '    cart { appliedGiftCards { lastCharacters balance { amount currencyCode } } }' +
    '    userErrors { message }' +
    '  }' +
    '}';

  function sameZnaki(v) {
    return String(v || '').replace(/[^0-9a-zA-Z]/g, '');
  }

  /* Kod w mailu jest w grupach po cztery - rozdzielamy tak samo w locie,
     zeby przepisywanie bylo latwiejsze i zeby bylo widac, ile juz wpisano. */
  function wGrupach(v) {
    return sameZnaki(v).toUpperCase().replace(/(.{4})(?=.)/g, '$1 ');
  }

  function pokazBlad(tekst) {
    wynik.hidden = true;
    if (blad) {
      blad.textContent = tekst;
      blad.hidden = false;
    }
    pole.setAttribute('aria-invalid', 'true');
  }

  function schowajBlad() {
    if (blad) blad.hidden = true;
    pole.removeAttribute('aria-invalid');
  }

  function zajety(tak) {
    btn.disabled = tak;
    if (spin) spin.hidden = !tak;
    if (btnTxt) btnTxt.textContent = tak ? napisy.czekaj : napisy.przycisk;
  }

  function sformatuj(ile, waluta) {
    var n = Number(ile);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pl', {
        style: 'currency',
        currency: waluta
      }).format(n);
    } catch (e) {
      return n.toFixed(2) + ' ' + waluta;
    }
  }

  pole.addEventListener('input', function () {
    var przed = pole.value;
    var koniec = pole.selectionStart === przed.length;
    var po = wGrupach(przed);
    if (po !== przed) {
      pole.value = po;
      if (koniec) pole.setSelectionRange(po.length, po.length);
    }
    schowajBlad();
    wynik.hidden = true;
  });

  if (reset) {
    reset.addEventListener('click', function () {
      wynik.hidden = true;
      schowajBlad();
      pole.value = '';
      pole.focus();
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    schowajBlad();
    wynik.hidden = true;

    /* Najpierw to, co widac bez pytania serwera - inaczej literowka w czasie
       przerwy dostaje komunikat o przerwie zamiast o za krotkim kodzie. */
    var kod = sameZnaki(pole.value);
    if (!kod) { pokazBlad(napisy.pusty); pole.focus(); return; }
    if (kod.length < 8) { pokazBlad(napisy.krotki); pole.focus(); return; }
    if (Date.now() < wolneOd) { pokazBlad(napisy.czekajBlad); return; }
    if (!token()) { pokazBlad(napisy.siec); return; }

    zajety(true);
    gql(MUT_KOSZYK)
      .then(function (d) {
        var id = d && d.data && d.data.cartCreate && d.data.cartCreate.cart && d.data.cartCreate.cart.id;
        if (!id) throw new Error('brak koszyka');
        return gql(MUT_KARTA, { cartId: id, kody: [kod] });
      })
      .then(function (d) {
        zajety(false);
        var odp = d && d.data && d.data.cartGiftCardCodesAdd;
        var karty = odp && odp.cart && odp.cart.appliedGiftCards;

        if (!karty || !karty.length) {
          nieudane += 1;
          if (nieudane >= 4) wolneOd = Date.now() + 10000;
          pokazBlad(napisy.brak);
          pole.focus();
          pole.select();
          return;
        }

        nieudane = 0;
        var k = karty[0];
        var ile = Number(k.balance.amount);
        if (kwota) kwota.textContent = sformatuj(k.balance.amount, k.balance.currencyCode);
        if (koncowka) koncowka.textContent = '•••• ' + k.lastCharacters;
        if (pusta) pusta.hidden = ile > 0;
        wynik.hidden = false;
        wynik.focus();
      })
      .catch(function () {
        zajety(false);
        pokazBlad(napisy.siec);
      });
  });
})();
